<template>
    <div>
        <div style="background-color: white;">
            <van-image width="100%" height="auto" :src="product.image || product.prodImage" style="min-height: 80px"/>
            <div style="background-color: white; margin: 0 20px; box-shadow:0px 2px 6px 0px rgba(194,194,194,0.5); border-radius:4px; position: relative; top: -30px; display: flex; flex-direction: column; align-items: center; overflow: hidden;">
                <div style="margin: 18px 0 9px 0; font-size: 18px; color: #066BEE; font-weight: bold; text-align: center;">
                    {{product.prodName}}
                </div>
                <div style="box-sizing: border-box; color: white; width: 100%; padding: 10px; background:linear-gradient(270deg,rgba(64,182,248,1) 0%,rgba(69,135,221,1) 100%);">
                    {{product.prodDescribe}}
                </div>
            </div>
        </div>
        <div class="block-buy">
            <div class="buy_title">购买人信息</div>
            <div class="buy_fields">
                <van-field v-model="formData.contactsName"
                           label="姓名："
                           label-align="right"
                           :border="false"/>
                <van-field v-model="formData.contactsPhone"
                           label="手机号码："
                           label-align="right"
                           :border="false"/>
                <van-field v-model="formData.contactsEmail"
                           label="邮箱："
                           label-align="right"
                           :border="false"/>
            </div>
        </div>
        <div class="block-buy">
            <div class="buy_title">体检人信息</div>
            <div style="display: flex; flex-direction: column;">
                <div style="padding: 10px 30px;">
                    <div v-if="showFamilyList.length > 0" style="display: flex; flex-wrap: wrap; align-items: center;">
                        <div v-for="(item,index) in showFamilyList" :key="index"
                             class="buy_item" :class="{buy_selectItem: item.selected}"
                             @click="selectFamilyClick(item)">
                            {{item.memberName}}
                        </div>
                    </div>
                    <div v-else style="margin-bottom: 10px">您尚未添加任何体检人</div>
                    <div style="display: flex; align-items: center;" @click="showAddFamily = !showAddFamily">
                        <van-icon name="add-o" style="margin-right: 5px"/>
                        <span>添加新的体检人</span>
                    </div>
                </div>
                <div v-if="showAddFamily" class="buy_fields">
                    <van-field v-model="newFamily.memberName"
                               label="姓名："
                               label-align="right"
                               :border="false"/>
                    <van-field v-model="newFamily.memberPhone"
                               label="手机号码："
                               label-align="right"
                               :border="false"/>
                    <van-field v-model="newFamily.memberIdCard"
                               label="身份证号："
                               label-align="right"
                               :border="false"/>
                    <van-field v-model="newFamily.userRelation"
                               label="关系类型："
                               label-align="right"
                               disabled
                               @click="showPicker = true"
                               :border="false"/>
                    <van-button size="small" style="align-self: center;" type="info" @click="addNewFamily">确定
                    </van-button>
                </div>
            </div>
        </div>
        <div class="block-buy">
            <div class="buy_title">发票信息</div>
            <div class="buy_fields">
                <div style="padding: 10px 30px;">
                    <div style="display: flex; flex-wrap: wrap; align-items: center;">
                        <div v-for="(item,index) in showInvoices" :key="index"
                             class="buy_item" :class="{buy_selectItem: selectInvoice.type === item.type}"
                             @click="selectInvoice = item;">
                            {{item.name}}
                        </div>
                    </div>
                </div>
                <div class="invoice" v-if="selectInvoice.type === '1'">
                    <van-field v-model="newInvoice.invoiceTitle"
                               label="发票抬头："
                               label-align="right"
                               label-width="110"
                               :border="false"/>
                    <van-field v-model="newInvoice.receiveEmail"
                               label="电子发票接收邮箱："
                               label-align="right"
                               label-width="110"
                               :border="false"/>
                    <van-field v-model="newInvoice.unifiedSocialCode"
                               label="统一社会信用代码："
                               label-align="right"
                               label-width="110"
                               :border="false"/>
                    <van-field v-model="newInvoice.mailAddress"
                               label="邮寄省/市/区："
                               label-align="right"
                               label-width="110"
                               disabled
                               @click="showAreaPop = true"
                               :border="false"/>
                    <van-field v-model="newInvoice.mailDetailsAddress"
                               label="详细地址："
                               label-align="right"
                               label-width="110"
                               :border="false"/>
                    <van-button type="info" size="small" style="align-self: center;" @click="updateInvoice">{{status === '1' ? '更新' : '保存'}}
                    </van-button>
                </div>
            </div>
        </div>
        <div class="block-buy">
            <div class="buy_title">体检分院</div>
            <div class="buy_fields">
                <van-field v-model="province"
                           label="选择省："
                           label-align="right"
                           :border="false"
                           disabled
                           @click="showCommonPop = true; selectedType = '1'"/>
                <van-field v-model="city"
                           label="选择市："
                           label-align="right"
                           :border="false"
                           disabled
                           @click="showCommonPop = true; selectedType = '2'"/>
                <van-field v-model="hospital"
                           label="选择分院："
                           label-align="right"
                           disabled
                           @click="showCommonPop = true; selectedType = '3'"
                           :border="false"/>
                <van-field v-model="formData.branchName"
                           label="分院地址："
                           label-align="right"
                           disabled
                           type="textarea"
                           :autosize="true"
                           :border="false"/>
            </div>
        </div>

        <van-button type="info" style="width: 100%" @click="save">提交订单</van-button>

        <van-popup v-model="showAreaPop" position="bottom">
            <div>
                <van-area :area-list="areaList" @cancel="showAreaPop = false" @confirm="areaConfirm" @change="areaChange"/>
            </div>
        </van-popup>

        <van-popup v-model="showCommonPop" position="bottom">
            <van-picker
                    show-toolbar
                    :columns="commonList"
                    @cancel="showCommonPop = false"
                    @confirm="commonConfirm"
                    @change="commonChange"
            />
        </van-popup>

        <van-popup v-model="showPicker" position="bottom">
            <van-picker show-toolbar :columns="columns" @cancel="showPicker = false" @confirm="onConfirm" @change="onChange"/>
        </van-popup>
    </div>
</template>

<script>

    import Vue from 'vue';
    import {Field, Icon, Area, Popup, Picker} from 'vant';
    import areaData from '@/utils/area.js'

    Vue.use(Field).use(Icon).use(Area).use(Popup).use(Picker);

    export default {
        name: "Buy",
        data() {
            return {
                status: '', //1 有发票 0无发票
                selectedType: '',
                province: '',
                city: '',
                hospital: '',
                provinceList:[],
                cityList: [],
                hospitalList: [],

                showCommonPop: false,
                areaList: areaData,
                showAreaPop: false,
                id: this.$route.query.productId || '',
                product: {},
                numberValue: this.$route.query.number,
                userInfo: {},
                ticketInfo: {},
                formData: {},

                selectFamily: [],
                showAddFamily: false,
                newFamily: {memberName: ''},
                showFamilyList: [],

                showInvoices: [{name: '无需发票', type: '0'}, {name: '普票', type: '1'}],
                selectInvoice: {name: '无需发票', type: '0'},
                newInvoice: { mailAddress: ''},

                showPicker: false,
                columns: ['父亲','母亲','夫妻','儿女','兄弟姐妹','自己','其他']
            }
        },
        computed: {
            commonList: function () {
                return this.selectedType === '1' ? this.provinceList.map(item => {return item.provinceName}) : this.selectedType === '2' ?
                        this.cityList.map(item => {return item.cityName}) : this.hospitalList.map(item => {return item.physicalName})
            }
        },
        created(){
            this.productInfo()
            this.familyList()
            this.invoiceInfo()
        },
        methods: {
            productInfo() {
                this.$axios.get('product/info', {params: {productId: this.id}}).then((res) => {
                    this.product = res.data;
                    this.getProvinceList()
                })
            },
            getProvinceList() {
                this.$axios.get('physical/province', {params: {physicalType: this.product.physicalFlag}}).then((res) => {
                    this.provinceList = res.data;
                })
            },
            familyList() {
                this.$axios.get('member/list', {params: {page: 0, size: 100000}}).then((res) => {
                    this.showFamilyList = res.data.rows
                    this.showFamilyList.map(item => {
                        return this.$set(item, 'selected', false)
                    })
                })
            },
            addNewFamily() {
                for (let item in this.newFamily) {//空数据校验
                    if (this.newFamily[item].length === 0) {
                        this.$notify({type: 'danger', message: '新增体检人信息填写不完整'});
                        return;
                    }
                }
                this.$axios.post("/member/addMember", this.newFamily).then(res => {
                    this.familyList()
                    for (let item in this.newFamily) {//数据重置
                        this.newFamily[item] = ''
                    }
                })
            },
            selectFamilyClick(item) {
                item.selected = !item.selected
                if (item.selected) {
                    this.selectFamily.push(item)
                } else {
                    this.selectFamily = this.selectFamily.filter(item1 => {
                        return item1.memberId !== item.memberId
                    })
                }
            },
            invoiceInfo() {
                this.$axios.get('/invoice/info').then(res => {
                    this.status = res.data.status
                    if (this.status === '1') {
                        const {invoiceId, userId, unifiedSocialCode, invoiceTitle, receiveEmail, mailAddress, mailDetailsAddress} = res.data.invoice
                        this.newInvoice = {invoiceId, userId, unifiedSocialCode, invoiceTitle, receiveEmail, mailAddress, mailDetailsAddress}
                    }
                    this.userInfo = res.data.user
                    this.$set(this.formData,'contactsEmail',this.userInfo.userEmail)
                    this.$set(this.formData,'contactsPhone',this.userInfo.userPhone)
                    this.$set(this.formData,'contactsName',this.userInfo.userName)
                })
            },
            updateInvoice() {
                for (let item in this.newInvoice) {//空数据校验
                    if (!this.newInvoice[item]) {
                        console.log(item,this.newInvoice[item])
                        this.$notify({type: 'danger', message: '发票信息填写不完整'});
                        return;
                    }
                }
                this.$axios.post("/invoice/edit", this.newInvoice).then(res => {
                    this.$set(this.newInvoice, 'invoiceId', res.data)
                    this.$notify({type: 'success', message: '发票信息已更新'});
                })
            },
            areaChange(picker,values) {
                this.dealAddress(values)
            },
            areaConfirm(values,index) {
                this.dealAddress(values)
                this.showAreaPop = false
            },
            dealAddress(values) {
                let province = values[0].name
                let city = values[1].name
                let area = values[2].name
                this.$set(this.newInvoice,'mailAddress',`${province} ${city} ${area}`)
            },
            commonConfirm(value,index) {
                this.showCommonPop = false
                this.dealData(value,index)
            },
            commonChange(picker, value, index) {
                this.dealData(value,index)
            },
            onChange(picker, value, index){
                this.$set(this.newFamily,'userRelation', value)
            },
            onConfirm(value, index){
                this.showPicker = false
                this.newFamily.userRelation = value
            },
            dealData(value,index) {
                if (this.selectedType === '1') {
                    this.province = value
                    this.$axios.get('physical/city', {params: {physicalType: this.product.physicalFlag, provinceCode:this.provinceList[index].provinceCode}}).then((res) => {
                        this.cityList = res.data;
                        this.hospitalList = []
                        this.city = ''
                        this.hospital = ''
                        this.formData.branchName = ''
                    })
                }else if(this.selectedType === '2'){
                    this.city = value
                    this.$axios.get('physical/list', {params: {physicalType: this.product.physicalFlag, cityCode:this.cityList[index].cityCode}}).then((res) => {
                        this.hospitalList = res.data;
                    })
                }else{
                    this.hospital = value
                    this.formData.branchName = this.hospitalList[index].physicalAddress
                }
            },
            save() {
                if (!this.formData.contactsName) {
                    this.$notify({type: 'danger', message: '请填写购买人姓名'});
                    return;
                }
                if (!this.formData.contactsPhone) {
                    this.$notify({type: 'danger', message: '请填写购买人手机'});
                    return;
                }
                if (!this.formData.contactsEmail) {
                    this.$notify({type: 'danger', message: '请填写购买人邮箱'});
                    return;
                }
                if (this.selectInvoice.type === '1') {
                    if (this.newInvoice.invoiceTitle && this.status === '0') {
                        this.$notify({type: 'danger', message: '请保存发票信息'});
                        return
                    }
                    this.formData.invoiceId = this.newInvoice.invoiceId
                }
                if (this.selectFamily.length === 0) {
                    this.$notify({type: 'danger', message: '请添加体检人信息'});
                    return;
                }
                if (!this.formData.branchName) {
                    this.$notify({type: 'danger', message: '请添加体检分院信息'});
                    return;
                }
                this.formData.invoiceType = this.selectInvoice.type
                this.formData.member = this.selectFamily.map(item=>{return item.memberId}).join(',')
                this.formData.price = this.$route.query.price
                this.formData.priceId = this.$route.query.priceId
                this.formData.productId = this.id
                this.formData.branchName = this.hospital;
                this.$axios.post('/buy/order',this.formData).then(res=>{
                    let orderId = res.data
                    this.$router.push({path: '/order', query:{productId: this.id, tradeNo: orderId}})
                })
            }
        }
    }
</script>

<style scoped>
    .buy_title {
        margin: 10px 0 20px 20px;
        text-align: start;
        font-size: 18px;
        font-weight: 500;
        background-color: #1989fa;
        color: white;
        align-self: flex-start;
        border-radius: 15px;
        padding: 5px 10px;
    }

    .buy_item {
        border: #cccccc 1px solid;
        color: #323233;
        padding: 2px 10px;
        border-radius: 15px;
        margin-right: 10px;
        margin-bottom: 10px;
    }

    .buy_selectItem {
        border: #35a1f4 1px solid;
        background-color: #1989fa;
        color: white;
    }

    .explain {
        margin-left: 5px;
        background-color: rgba(255, 0, 0, 0.71);
        color: white;
        padding: 5px;
        flex: 1;
    }

    .block-buy {
       width: 100%;
        margin-top: 10px;
        padding: 10px 0;
        background-color: white;
        display: flex;
        flex-direction: column;
    }

    .block-buy .van-field__control {
        border: #F3F3F3 1px solid;
        padding: 2px 5px;
    }

    .block-buy .van-field__label {
        padding: 2px 0;
    }

    .block-buy .van-field__control:disabled {
        color: #323233;
    }

    .invoice {
        display: flex; flex-direction: column;
    }

    .invoice .van-field__label {
        /*font-size: 12px;*/
        width: 126px !important;
    }

    .buy_fields {
        display: flex; flex-direction: column;
    }

    .buy_fields .van-cell {
        padding: 6px 16px;
    }
</style>
